import { render, staticRenderFns } from "./BusinessStartupPageCustomerOrderCreate.vue?vue&type=template&id=ec2ea7ca&"
import script from "./BusinessStartupPageCustomerOrderCreate.vue?vue&type=script&lang=ts&"
export * from "./BusinessStartupPageCustomerOrderCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec2ea7ca')) {
      api.createRecord('ec2ea7ca', component.options)
    } else {
      api.reload('ec2ea7ca', component.options)
    }
    module.hot.accept("./BusinessStartupPageCustomerOrderCreate.vue?vue&type=template&id=ec2ea7ca&", function () {
      api.rerender('ec2ea7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/BusinessStartupPageCustomerOrderCreate.vue"
export default component.exports